export const PIVOT_TARGET_TO = 'pivotTargetTo';
export const PIVOT_SOURCE_FROM = 'pivotSourceFrom';
export const PIVOT_SOURCE_AT = 'pivotSourceCreatedOn';
export const PIVOT_TARGET_AT = 'pivotTargetCreatedOn';
export const PIVOT_SOURCE_OPPORTUNITY_UID = 'pivotSourceOpportunityUid';
export const PIVOT_SOURCE_CONVERSATION_UID = 'pivotSourceConversationUid';
export const PIVOT_TARGET_OPPORTUNITY_UID = 'pivotTargetOpportunityUid';
export const PIVOT_TARGET_CONVERSATION_UID = 'pivotTargetConversationUid';
export const PIVOT_TARGET_REASON = 'pivotTargetReason';
export const PIVOT_SOURCE_REASON = 'pivotSourceReason';
export const LEAD_STATE_ABBR = 'leadStateAbbr';
export const ADDRESS_STATE = 'addressState';
export const OPPORTUNITY_UID = 'opportunityUid';
export const CONVERSATION_ID = 'conversationId';
export const FLAG_PAYMENT_FAILED = 'flagPaymentFailed';
export const FINAL_TECHNICAL_OUTCOME = 'finalTechnicalOutcome';
export const LAST_EVENT = 'lastEvent';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const AGENT_NAME = 'agentName';
export const AGENT_ID = 'userId';

export const APPLICATION_DETAILS_TBL_LABEL_MAP: Record<string, string> = {
    userId: "Agent ID",
    tenantTitle: "Agency Title",
    agentName: "Agent Name",
    userEmail: "Agent Email",
    userWritingNumber: "Writing Number",
    userPhoneNumber: "Agent Phone Number",
}

export const APPLICATION_DETAILS_LABEL_MAP: Record<string, string> = {
    //Agent Details
    userId: "ID",
    tenantTitle: "Agency Title",
    agentName: "Name",
    userEmail: "Email",
    userWritingNumber: "Writing Number",
    userPhoneNumber: "Phone",

    //Application Summary
    opportunityUid: "Opportunity UID",
    conversationId: "Conversation ID",
    policyNumber: "Policy Number",
    proTitle: "Product Title",
    productVariantTitle: "Product Variant Title",
    applicationStatus: "Status",
    createdOn: "Created On",
    finalTechnicalOutcome: "Final Technical Outcome",
    lastEvent: "Last Event",
    eventDateTime: "Event Date Time",
    nextExpectedEvent: "Next Expected Event",
    flagTobaccoUse: "Nicotine Use",
    applicationType: "Application Type",
    uiLanguage: "Source Language",

    pivotSourceFrom: "Pivoted From",
    pivotSourceCreatedOn: "Pivot Source Created On",
    pivotSourceOpportunityUid: "Pivot Source Opportunity Uid",
    pivotSourceConversationUid: "Pivot Source Conversation Uid",
    pivotSourceReason: "Pivot Source Reason",
    pivotTargetTo: "Pivoted To",
    pivotTargetCreatedOn: "Pivot Target Created On",
    pivotTargetOpportunityUid: "Pivot Target Opportunity Uid",
    pivotTargetConversationUid: "Pivot Target Conversation Uid",
    pivotTargetReason: "Pivot Target Reason",
    
    //Applicant Details
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    gender: "Gender",
    age: "Age",
    dateOfBirth: "Date of Birth",
    phoneNo: "Phone Number",
    email: "Email",
    monthlyIncome: "Monthly Income",

    //Location Details
    leadStateAbbr: "Issue State",
    leadZipCode: "Issue Zip Code",
    addressCity: "Address City",
    addressState: "Address State",
    addressZipCode: "Address Zip Code",
    
    //Quote Details
    faceAmount: "Face Amount",
    termLength: "Term Length",
    riders: "Riders",
    quoteAmount: "Quote Amount",
    flagExtraWithDuration: "Flag Extra With Duration",

    //Payment Details
    paymentFrequency: "Payment Frequency",
    paymentAmount: "Payment Amount",
    paymentMethod: "Payment Method",
    paymentOn: "Payment On",
    paymentMethodLabel: "Payment Method Label",
    paymentEffectiveDate: "Payment Effective Date",
    flagPaymentFailed: "Flag Payment Failed",

    //Verification & System Info
    threePsStartedOn: "3PS Started On",
    threePsCompletedOn: "3PS Completed On",
    threePsTimeInMinutes: "3PS Time in Minutes",
    threePsResponse: "3PS Response",
    lastLnidCallOn: "Last LNID Call On",
    lnidResponseCode: "LNID Response Code",
    cviScore: "CVI Score",
    rasDeclineQuestion: "RAS Decline Question",
    rasDeclineReason: "RAS Decline Reason",
};

export const APPLICATION_DETAILS_ORDERED_KEYS = Object.keys(APPLICATION_DETAILS_LABEL_MAP);

export const APPLICATION_DETAILS_AGENT_KEYS = new Set([
    AGENT_ID,
    "tenantTitle",
    AGENT_NAME,
    "userEmail",
    "userWritingNumber",
    "userPhoneNumber",
]);

export const APPLICATION_DETAILS_APPLICATION_SUMMARY_KEYS = new Set([
    OPPORTUNITY_UID,
    CONVERSATION_ID,
    "policyNumber",
    "proTitle",
    "productVariantTitle",
    "applicationStatus",
    "createdOn",
    LAST_EVENT,
    "eventDateTime",
    FINAL_TECHNICAL_OUTCOME,
    "nextExpectedEvent",
    "flagTobaccoUse",
    "applicationType",
    "uiLanguage",
]);

export const APPLICATION_DETAILS_PIVOT_KEYS = new Set([
    PIVOT_SOURCE_FROM,
    PIVOT_SOURCE_AT,
    PIVOT_SOURCE_OPPORTUNITY_UID,
    PIVOT_SOURCE_CONVERSATION_UID,
    PIVOT_SOURCE_REASON,
    PIVOT_TARGET_TO,
    PIVOT_TARGET_AT,
    PIVOT_TARGET_OPPORTUNITY_UID,
    PIVOT_TARGET_CONVERSATION_UID,
])

export const APPLICATION_DETAILS_APPLICATION_DETAILS_KEYS = new Set([
    "firstName",
    "middleName",
    "lastName",
    "gender",
    "age",
    "dateOfBirth",
    "phoneNo",
    "email",
    "monthlyIncome",
])

export const APPLICATION_DETAILS_APPLICATION_LOCATION_KEYS = new Set([
    LEAD_STATE_ABBR,
    "leadZipCode",
    "addressCity",
    ADDRESS_STATE,
    "addressZipCode",
])

export const APPLICATION_DETAILS_QUOTE_KEYS = new Set([
    "faceAmount",
    "termLength",
    "riders",
    "quoteAmount",
    "flagExtraWithDuration",
])

export const APPLICATION_DETAILS_PAYMENT_KEYS = new Set([
    "paymentFrequency",
    "paymentAmount",
    "paymentOn",
    "paymentMethod",
    "paymentMethodLabel",
    "paymentEffectiveDate",
    FLAG_PAYMENT_FAILED,
])

export const APPLICATION_DETAILS_VERIFICATION_KEYS = new Set([
    "rasDeclineReason",
    "rasDeclineQuestion",
    "lnidResponseCode",
    "cviScore",
    "threePsStartedOn",
    "threePsCompletedOn",
    "threePsTimeInMinutes",
    'threePsResponse',
    "lastLnidCallOn"
])

export const APPLICATION_DETAILS_CATEGORY_MAP = [
    { name: "agent", keys: APPLICATION_DETAILS_AGENT_KEYS },
    { name: "summary", keys: APPLICATION_DETAILS_APPLICATION_SUMMARY_KEYS },
    { name: "pivot", keys: APPLICATION_DETAILS_PIVOT_KEYS },
    { name: "applicant", keys: APPLICATION_DETAILS_APPLICATION_DETAILS_KEYS },
    { name: "location", keys: APPLICATION_DETAILS_APPLICATION_LOCATION_KEYS },
    { name: "quote", keys: APPLICATION_DETAILS_QUOTE_KEYS },
    { name: "payment", keys: APPLICATION_DETAILS_PAYMENT_KEYS },
    { name: "verification", keys: APPLICATION_DETAILS_VERIFICATION_KEYS },
];

export const APPLICATION_DETAILS_KEY_TO_CATEGORY: Record<string, string> = (() => {
    const map: Record<string, string> = {};
    for (const { name, keys } of APPLICATION_DETAILS_CATEGORY_MAP) {
        for (const key of keys) {
            map[key] = name;
        }
    }
    return map;
})();

export const APPLICATION_DETAILS_AMOUNT_KEYS = new Set(['quoteAmount', 'faceAmount']);
export const APPLICATION_DETAILS_DATE_KEYS = new Set(['createdOn', 'eventDateTime', 'paymentOn', 'threePsStartedOn', 'threePsCompletedOn', 'lastLnidCallOn']);
export const APPLICATION_DETAILS_DATE_ONLY_KEYS = new Set(['dateOfBirth', 'paymentEffectiveDate']);
